import Box from '@mui/material/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import { VOUCHER_TITLE_TS_DETAIL } from 'constants/Icons';
import { useState } from 'react';
import { Navigation, Pagination, Virtual } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getLinkCDNImageList } from 'utils/ImageUtils';
import ListPromoGift from '../ListPromoGift';
import styles from './styles.module.css';

function PromotionPC({ loading = false, listsPromo = [], handleOpen, listPromoProduct = [] }) {
  const [, setSwiperRef] = useState(null);

  return listsPromo?.length > 0 ? (
    <>
      <Box className={styles.gift}>
        <VOUCHER_TITLE_TS_DETAIL />
        <Typography className={styles.titleGift}>Quà Tặng</Typography>
        <Typography className={styles.titleDetail} onClick={handleOpen}>
          Xem chi tiết <KeyboardArrowRightIcon style={{ color: '#0E1983', fontSize: '18px', fontWeight: 'bold' }} />
        </Typography>
      </Box>
      {loading ? (
        <Skeleton width={300} height={64} />
      ) : (
        <Grid container direction="row" className={clsx(styles.wrapPromoList, listPromoProduct?.length > 3 && styles.listSwipperPromo)}>
          <Grid>
            <Swiper onSwiper={setSwiperRef} slidesPerView={3} navigation modules={[Pagination, Navigation, Virtual]}>
              {listPromoProduct?.map((item) => (
                <SwiperSlide key={item?.productData?.product?.slug}>
                  <ListPromoGift
                    slugProduct={item?.productData?.product?.slug}
                    link={`/product/${item?.slug || ''}`}
                    srcImagesProxy={getLinkCDNImageList(item?.productData?.product?.imageUrls) || item.productData?.product?.imageUrls}
                    width={48}
                    height={48}
                    imageName={item?.productData?.product?.name}
                    lengthList={listPromoProduct.length}
                    name={item?.productData?.product?.name}
                  />

                  <span slot="wrapper-end" className={clsx(styles.plus, listPromoProduct?.length <= 3 && styles.listResize)}>
                    +
                  </span>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      )}
    </>
  ) : (
    ''
  );
}

export default PromotionPC;
